<template>
  <div
    class="relative min-h-106px"
    :class="{ 'loading-fill': fill }">
    <div
      v-if="loading"
      class="absolute left-1/2 top-4 transform -translate-x-1/2 z-10">
      <LoadingSpinner />
    </div>
    <div
      class="transition-opacity duration-500"
      :class="{
        'opacity-25 pointer-events-none': loading,
        'loading-fill': fill,
      }">
      <slot />
    </div>
  </div>
</template>

<script>
import LoadingSpinner from '@/components/Loading/LoadingSpinner.vue';

export default {
  name: 'Loading',
  props: {
    loading: {
      type: Boolean,
      default: false,
    },
    fill: {
      type: Boolean,
      default: false,
    },
  },
  components: {
    LoadingSpinner,
  },
};
</script>

<style scoped>
.loading-fill {
  height: 100%;
  min-height: 0;
  flex: 1 1 auto;
  display: flex;
  flex-direction: column;
  overflow: hidden;
}

.loading-fill > .loading-fill {
  flex: 1 1 auto;
  height: auto;
  min-height: 0;
}
</style>
